export default async (_ctx, inject) => {
  if (typeof window === 'undefined') {
    inject('echarts', null)
    return
  }

  const echarts = await import('echarts/core')
  const charts = await import('echarts/charts')
  const components = await import('echarts/components')
  const features = await import('echarts/features')
  const renderers = await import('echarts/renderers')

  echarts.use([
    components.TitleComponent,
    components.TooltipComponent,
    components.GridComponent,
    components.DatasetComponent,
    components.TransformComponent,
    components.LegendComponent,
    components.ToolboxComponent,
    charts.BarChart,
    charts.LineChart,
    charts.TreemapChart,
    charts.PieChart,
    charts.FunnelChart,
    features.LabelLayout,
    features.UniversalTransition,
    renderers.CanvasRenderer
  ])

  inject('echarts', echarts)
}


